// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "ba3ba11",
    "hash": "ba3ba11",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "ba3ba11",
    "semverString": null
};
/* tslint:enable */
